/**
 * Module-level token store
 * Holds the accessToken in a plain JS variable — outside React/Redux.
 * - Survives re-renders (no re-render triggered on set)
 * - Resets on page reload (by design — refreshed silently on boot)
 * - Never written to disk — XSS cannot steal it
 *
 * Only refreshToken is persisted (localStorage) to survive page reloads.
 */

let _accessToken = null;
let _csrfToken = null;

export const setAccessToken = (token) => { _accessToken = token; };
export const getAccessToken = () => _accessToken;
export const clearAccessToken = () => { _accessToken = null; };

export const setCsrfToken = (token) => { _csrfToken = token; };
export const getCsrfToken = () => _csrfToken;
export const clearCsrfToken = () => { _csrfToken = null; };

/** Persist refresh token to localStorage (only token that touches disk) */
export const setRefreshToken = (token) => localStorage.setItem("refreshToken", token);
export const getRefreshToken = () => localStorage.getItem("refreshToken");
export const clearRefreshToken = () => localStorage.removeItem("refreshToken");

/** Clear all auth state — call on logout */
export const clearAllTokens = () => {
    clearAccessToken();
    clearCsrfToken();
    clearRefreshToken();
};
